/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_UnarchiveInputs */

const en_cargos_unarchive = /** @type {(inputs: Cargos_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive`)
};

const es_cargos_unarchive = /** @type {(inputs: Cargos_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarchivar`)
};

/**
* | output |
* | --- |
* | "Unarchive" |
*
* @param {Cargos_UnarchiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_unarchive = /** @type {((inputs?: Cargos_UnarchiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_UnarchiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_unarchive(inputs)
	return es_cargos_unarchive(inputs)
});